import { createAsyncThunk } from "@reduxjs/toolkit";
import type { Dependencies } from "@redux/store";
import type { ManageObjectivesCommand } from "@shared-kernel/application/ports/student/student-repository";

export const manageObjectives = createAsyncThunk<void, ManageObjectivesCommand, { extra: Partial<Dependencies> }>(
  "student/manageObjectives",
  async (payload: ManageObjectivesCommand, { extra: { studentRepository } }) => {
    return studentRepository!.manageObjectives(payload);
  },
);
